<script setup lang="ts">
  const collapsed = ref(false)
</script>

<template>
  <AppAdminProvider>
    <div class="admin-shell admin-font" :class="{ 'admin-shell--collapsed': collapsed }">
      <AppAdminSidebar v-model:collapsed="collapsed" />
      <div class="admin-shell__main">
        <AppAdminHeader v-model:collapsed="collapsed" />
        <main class="admin-shell__content">
          <slot />
        </main>
        <AppAdminFooter />
      </div>
    </div>
  </AppAdminProvider>
</template>

<style lang="scss" scoped>
  .admin-shell {
    --admin-sidebar-w: 270px;
    --admin-gap: 20px;
    --admin-header-h: 75px;

    box-sizing: border-box;
    height: 100vh;
    overflow: hidden;
    padding: var(--admin-gap);
    background: #f0f5f9;
  }

  .admin-shell--collapsed {
    --admin-sidebar-w: 64px;
  }

  .admin-shell__main {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-width: 0;
    min-height: 0;
    margin-left: calc(var(--admin-sidebar-w) + var(--admin-gap));
    /* Fixed header is out of flow — reserve space so content starts below it */
    padding-top: calc(var(--admin-header-h) + var(--admin-gap));
  }

  .admin-shell__content {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
</style>
